<template lang="pug">
div.track-pop
  v-dialog(v-model="openPopup" scrollable persistent width="370")
    v-card.tracking-pop
      v-card-text
        .close
          img(:src="iconClose" alt="Cerrar pop-up NPS" style="float:right" width="12px" @click="closeAlertPopup")
        p.omnesMedium.text-primary(style="text-align: center;") Seguimiento de mis solicitudes
        p.omnesRegular.text-secondary Aquí podrás visualizar el resumen de tus
          br
          |solicitudes que están en proceso.
        CardTrackingSolicitudes(
          v-for="(req, index) in requirements" :key="req.id"
          :title="req.title"
          :code="req.code"
          :percent="req.percent"
          :selected="req.selected"
          :status="req.status"
          :requirement="req.requirement"
          :showInsuranceID="true"
        )
</template>

<script>
import CardTrackingSolicitudes from '@/components/mis-seguros/CardTrackingSolicitudes.vue'

export default {
  props: [
    'openPopup',
    'buttonClose',
    'requirements'
  ],
  data () {
    return {
      iconClose: require('@/assets/nps/icon-close-nps-modal.svg')
    }
  },
  methods: {
    closeAlertPopup (item) {
      this.$emit('closeAlertPopup', item)
    }
  },
  mounted () {
  },
  components: {
    CardTrackingSolicitudes
  }
}
</script>

<style>
.tracking-pop .v-card__text {
  padding: 34px 18px;
}

.tracking-pop .close {
  cursor: pointer;
  margin: 5px;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.tracking-pop p,
.tracking-pop span {
  color: #535D66;
  margin: 0;
}

.tracking-pop .text-primary {
  color: #454A6C;
  margin-bottom: 20px;
}

.tracking-pop .text-secondary {
  color: #454A6C;
  margin-bottom: 20px !important;
  font-size: 17px;
}

.tracking-pop .text-primary,
.tracking-pop .text-primary span {
  font-size: 18px;
  line-height: 20px;
  color: #454A6C;
}

.track-pop .v-dialog:not(.v-dialog--fullscreen) {
  min-height: 90%;
  max-height: 90%;
}

@media screen and (max-width: 385px) {
  .track-pop .v-dialog:not(.v-dialog--fullscreen) {
      min-height: 90%;
      max-height: 90%;
  }
}

@media screen and (min-width: 600px) {
  .track-pop .v-dialog:not(.v-dialog--fullscreen) {
      min-height: 90%;
      max-height: 90%;
  }
  .track-pop .v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--scrollable {
    width: 420px !important;
  }
}

@media screen and (min-width: 1024px) {
  .tracking-pop .v-card__text {
    padding: 25px;
  }

  .tracking-pop .close {
    padding: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/PopupTrackingSolicitudes.vue